function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 1C7.435 1 3.75 4.559 3.75 8.967c0 5.46 7.37 13.467 7.706 13.79a.732.732 0 001.088 0c.335-.323 7.706-8.33 7.706-13.79C20.25 4.599 16.523 1 12 1z",
  fill: "#FFF0E7"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.386 13.75h-.518v-3.015h-3.694v2.961h-.518v-3.664a.99.99 0 00-.223-.622.912.912 0 00-.702-.344h-.247l3.515-3.568 3.569 3.622h-.256c-.348 0-.585.2-.702.344a.99.99 0 00-.224.621v3.665z",
  fill: "#FF6C0E",
  stroke: "#FF6C0E",
  strokeWidth: 1.5
});

function SvgMarkerPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "/img/markerPoint.svg";
export { SvgMarkerPoint as ReactComponent };